export default {
  1: 'PEASANT',
  2: 'BURNINGMAN',
  3: 'WOODCUTTER',
  4: 'FLETCHER',
  5: 'TUNNELER',
  6: 'HUNTER',
  7: 'QUARRYMASON',
  8: 'QUARRYWORKER',
  9: 'QUARRYOX',
  10: 'PITCHMAN',
  11: 'WHEATFARMER',
  12: 'HOPSFARMER',
  13: 'APPLEFARMER',
  14: 'DAIRYFARMER',
  15: 'MILLER',
  16: 'BAKER',
  17: 'BREWER',
  18: 'POLETURNER',
  19: 'SMITH',
  20: 'ARMORER',
  21: 'TANNER',
  22: 'E_ARCHER',
  23: 'E_XBOW',
  24: 'E_SPEAR',
  25: 'E_PIKE',
  26: 'E_MACE',
  27: 'E_SWORD',
  28: 'E_KNIGHT',
  29: 'E_LADDER',
  30: 'E_ENGINEER',
  31: 'MINER',
  32: 'TRANSPORTMINER',
  33: 'PRIEST',
  34: 'HEALER',
  35: 'DRUNK',
  36: 'INNKEEPER',
  37: 'E_MONK',
  38: 'UNKNOWN1',
  39: 'S_CATAPULT',
  40: 'S_TREBUCHET',
  41: 'S_MANGONEL',
  42: 'TRADER',
  43: 'TRADERHORSE',
  44: 'ANTELOPE (SH: DEER)',
  45: 'LION (SH: WOLF)',
  46: 'RABBIT',
  47: 'CAMEL (SH: BEAR)',
  48: 'CROW',
  49: 'SEAGULL',
  50: 'S_SIEGETENT',
  51: 'COW',
  52: 'HUNTERDOG',
  53: 'FIREFIGHTER',
  54: 'GHOST',
  55: 'LORD',
  56: 'LADY',
  57: 'JESTER',
  58: 'S_TOWER',
  59: 'S_BATTERINGRAM',
  60: 'S_SHIELD',
  61: 'S_BALLISTA',
  62: 'CHICKEN',
  63: 'MOTHER',
  64: 'CHILD',
  65: 'JUGGLER',
  66: 'FIREEATER',
  67: 'CAGEDOG',
  68: 'BURNING_ANIMAL_1',
  69: 'BURNING_ANIMAL_2',
  70: 'A_ARCHER',
  71: 'A_SLAVE',
  72: 'A_SLINGER',
  73: 'A_ASSASSIN',
  74: 'A_HARCHER',
  75: 'A_SWORDSMAN',
  76: 'A_FIRETHROWER',
  77: 'S_FBALLISTA',
  78: 'UNKNOWN2',
  79: 'UNKNOWN3'
}
